module.exports = __webpack_public_path__ + "static/img/helmet.bacb669.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/helmet.png
// module id = tOO1
// module chunks = 0